import {
  CreatePaylinkTransactionHookDto,
  PaylinkTransactionHookEntity,
} from '@heliofi/common';
import { ApiAdapter } from '../../ApiAdapter';

export class TransactionWebhookSDK {
  private readonly apiAdapter: ApiAdapter;

  constructor(apiAdapter: ApiAdapter) {
    this.apiAdapter = apiAdapter;
  }

  async createTransactionWebhook(
    payload: CreatePaylinkTransactionHookDto,
  ): Promise<PaylinkTransactionHookEntity> {
    return this.apiAdapter.post(
      '/webhook/paylink/transaction',
      payload,
      'Failed to create transaction webhook',
    );
  }

  async getAllTransactionWebhooks(
    paylinkId: string,
  ): Promise<PaylinkTransactionHookEntity[]> {
    return this.apiAdapter.get(
      '/webhook/paylink/transaction',
      'Failed to get all transaction webhooks',
      { paylinkId },
    );
  }

  async getTransactionWebhook(
    webhookId: string,
  ): Promise<PaylinkTransactionHookEntity> {
    return this.apiAdapter.get(
      `/webhook/paylink/transaction/${webhookId}`,
      'Failed to get transaction webhook',
    );
  }

  async deleteTransactionWebhook(webhookId: string): Promise<void> {
    return this.apiAdapter.delete(
      `/webhook/paylink/transaction/${webhookId}`,
      'Failed to delete transaction webhook',
    );
  }
}
